// ** Modules
import dynamic from 'next/dynamic';

// Avoid SSR "window is not defined" errors
const ReactApexcharts = dynamic(() => import('react-apexcharts'), {
	ssr: false
});

export default ReactApexcharts;
